import {Collection} from 'vue-mc';
import Config from "../config/config";

export default class menuCollection extends Collection {

  // Route configuration
  routes() {
    return {
      fetch: Config.localApiURL + 'authorization/getMenu/' + Config.projectId + '?token=' + localStorage.getItem('jwt')
    }
  }
}



// WEBPACK FOOTER //
// ./src/collections/menuCollection.js